import { render } from "./aging-report-details.vue?vue&type=template&id=c6414d92"
import script from "./aging-report-details.vue?vue&type=script&lang=js"
export * from "./aging-report-details.vue?vue&type=script&lang=js"

import "./aging-report-details.vue?vue&type=style&index=0&id=c6414d92&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__